import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { passwordPolicyError, PASSWORD_HELP_TEXT } from "../lib/passwordPolicy";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    const pwErr = passwordPolicyError(pw);
    if (pwErr) { setErr(pwErr); return; }
    if (pw !== pw2) { setErr("As senhas não coincidem"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Senha redefinida com sucesso");
      nav("/login");
    } catch (ex) { setErr(formatApiError(ex)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-slate-200 rounded-xl p-8 shadow-sm" data-testid="reset-form">
        <Link to="/login" className="text-xs text-blue-600 hover:underline">← Voltar ao login</Link>
        <h1 className="mt-4 font-heading text-2xl font-bold text-slate-900">Nova senha</h1>
        <p className="text-slate-500 text-sm mt-1">Escolha uma senha nova para sua conta.</p>
        <div className="mt-6 space-y-4">
          <div>
            <Label>Nova senha</Label>
            <Input type="password" value={pw} onChange={e => setPw(e.target.value)} required data-testid="reset-pw" />
            <p className="text-xs text-slate-400 mt-1">{PASSWORD_HELP_TEXT}</p>
          </div>
          <div><Label>Confirmar senha</Label><Input type="password" value={pw2} onChange={e => setPw2(e.target.value)} required data-testid="reset-pw2" /></div>
          {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">{err}</div>}
          <Button className="w-full bg-blue-600 hover:bg-blue-700" disabled={busy || !token} data-testid="reset-submit">
            <KeyRound size={16} /> {busy ? "Salvando..." : "Redefinir senha"}
          </Button>
        </div>
      </form>
    </div>
  );
}
